import apiFetch from '../apiFetch'

export default function (idVerraco, token) {
  return apiFetch({endPoint: `FichaVerraco/putCambiarVigilado?idVerraco=` + idVerraco, method: 'GET', body: null, token: token})
}
